import SectionHeading from './SectionHeading'
import SectionSubText from './SectionSubText'

export default function SwitchOLMBenefits({
    heading = 'Why Switch to OLM?',
    subheading = 'When you’re competing for motivated sellers, you can’t afford “print and pray.” Unlike other direct mail companies, OLM is:',
}) {
    const benefits = [
        {
            title: 'Investor-Founded',
            desc: 'we know what makes sellers pick up the phone.',
        },
        {
            title: 'Coach-Supported',
            desc: 'you get a dedicated marketing coach, not a ticket system.',
        },
        {
            title: 'Fast & Flexible',
            desc: 'average 3-day turnaround vs. 1–2 weeks at generic shops.',
        },
        {
            title: 'Data-Driven',
            desc: 'track every call, response, and ROI metric.',
        },
        {
            title: 'Highly Personalized',
            desc: 'hands-on guidance, real coaching, real support.',
        },
    ]

    return (
        <section
            aria-labelledby="ready-elevate-heading"
            className="py-5 md:py-5">
            <div className="relative overflow-hidden rounded-3xl md:rounded-[56px]">
                {/* Soft peach-to-white background gradient */}
                <div className="absolute inset-0 bg-gradient-to-b from-[#fff5ec] via-[#fff5ec]/80 to-white" />

                {/* Content */}
                <div className="relative px-5 md:px-10 py-12 md:py-16">
                    {/* Heading */}
                    <div className="max-w-3xl mx-auto text-center">
                        <SectionHeading>
                            <span className="text-[#ED5C2F]">{heading}</span>
                        </SectionHeading>
                        <SectionSubText>{subheading}</SectionSubText>
                    </div>

                    {/* Benefits cards */}
                    <div className="mt-10 md:mt-12 max-w-6xl mx-auto">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5 md:gap-7 justify-items-center">
                            {benefits.map((b, i) => (
                                <div
                                    key={b.title}
                                    className={[
                                        // Center last row items like mock (3-over-2 layout)
                                        i === 3 ? 'lg:col-start-2' : '',
                                        i === 4 ? 'lg:col-start-4' : '',
                                        'w-full sm:w-full max-w-[520px] rounded-lg lg:col-span-2',
                                        'border-solid border-[2px] border-[#ED5C2F] shadow-[0_0_10px_0_rgba(250,179,49,0.5)]',
                                        'p-6 md:p-8 text-center',
                                    ]
                                        .filter(Boolean)
                                        .join(' ')}>
                                    <h3 className="text-xl font-semibold text-olm-new-black">
                                        {b.title}
                                    </h3>
                                    <p className="mt-3 md:mt-4 text-olm-gray text-base md:text-lg leading-7">
                                        {b.desc}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
